import React, { useEffect, useState } from 'react';
import { getConsent, setConsent, CONSENT_OPEN_EVENT } from '../../utils/consent';

const S = {
  banner: {
    position: 'fixed',
    bottom: '16px',
    left: '16px',
    right: '16px',
    maxWidth: '520px',
    margin: '0 auto',
    zIndex: 9999,
    background: '#111827',
    color: '#e5e7eb',
    borderRadius: '12px',
    boxShadow: '0 8px 30px rgba(0,0,0,0.35)',
    padding: '16px 20px',
    fontSize: '14px',
    lineHeight: 1.5,
  },
  actions: { display: 'flex', gap: '10px', marginTop: '12px', flexWrap: 'wrap' },
  accept: {
    background: '#2563eb',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    padding: '8px 18px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  decline: {
    background: 'transparent',
    color: '#9ca3af',
    border: '1px solid #374151',
    borderRadius: '8px',
    padding: '8px 18px',
    fontSize: '14px',
    cursor: 'pointer',
  },
  link: { color: '#93c5fd', textDecoration: 'underline' },
};

/**
 * Self-hosted analytics consent banner (replaces Termly).
 * Shown until the visitor makes a choice; re-openable via the footer
 * "Consent Preferences" link (openConsentPreferences()).
 */
const ConsentBanner = () => {
  const [visible, setVisible] = useState(() => !getConsent());

  useEffect(() => {
    const reopen = () => setVisible(true);
    window.addEventListener(CONSENT_OPEN_EVENT, reopen);
    return () => window.removeEventListener(CONSENT_OPEN_EVENT, reopen);
  }, []);

  if (!visible) return null;

  const choose = (value) => {
    setConsent(value);
    setVisible(false);
  };

  return (
    <div style={S.banner} role="dialog" aria-label="Analytics consent">
      <div>
        We use privacy-friendly, first-party analytics to understand how QuantApe is used — no
        third-party trackers, no ads, and your IP address is never stored. See our{' '}
        <a href="/cookies" style={S.link}>Cookie Policy</a> and{' '}
        <a href="/privacy" style={S.link}>Privacy Policy</a>.
      </div>
      <div style={S.actions}>
        <button type="button" style={S.accept} onClick={() => choose('accepted')}>
          Allow analytics
        </button>
        <button type="button" style={S.decline} onClick={() => choose('declined')}>
          Decline
        </button>
      </div>
    </div>
  );
};

export default ConsentBanner;
